import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, t, p, f, i, m) {
  return e(), o("svg", a, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "M11.03 5.478a.75.75 0 0 1 .07.977l-.073.084-4.665 4.633h13.11a.75.75 0 0 1 .102 1.494l-.102.007-13.234-.001 4.789 4.757a.75.75 0 0 1 .075.976l-.072.085a.75.75 0 0 1-.976.075l-.085-.072-6.016-5.977a.748.748 0 0 1-.22-.585l-.001-.008a.75.75 0 0 1 .426-.677L9.97 5.475a.75.75 0 0 1 1.061.003Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(n, [["render", s]]);
export {
  u as default
};
